@if(!popup || visible) {
    <div #container
        [ngClass]="{'p-menu p-component': true, 'p-menu-overlay': popup}"
        [class]="styleClass"
        [ngStyle]="style"
        [@overlayAnimation]="{value: 'visible', params: {showTransitionParams: showTransitionOptions, hideTransitionParams: hideTransitionOptions}}"
        [@.disabled]="popup !== true"
        (@overlayAnimation.start)="onOverlayAnimationStart($event)"
        (@overlayAnimation.done)="onOverlayAnimationEnd($event)"
        (click)="onOverlayClick($event)">
        <ul
            class="p-menu-list p-reset"
            role="menu">

            @if(hasSubMenu()) {
                @for (submenu of model; track submenu){

                    @if(submenu.separator) {
                        <li class="p-menu-separator"
                            role="separator"
                            [ngClass]="{
                                'p-hidden': (submenu.isVisible | async) === false, 
                                'p-disabled': (submenu.isEnabled | async) === false
                            }">
                        </li>
                    } @else {
                        <li role="none"
                            class="p-submenu-header"
                            [attr.data-automationid]="submenu.automationId"
                            [ngClass]="{
                                'p-hidden': (submenu.isVisible | async) === false, 
                                'p-disabled': (submenu.isEnabled | async) === false
                            }">
                            @if(submenu.escape !== false) {
                                <span>{{submenu.label}}</span>
                            } @else {
                                <span [innerHTML]="submenu.label"></span>
                            }
                        </li>
                    }

                    @for(item of submenu.items; track item) {
                        @if(item.separator) {
                            <li class="p-menu-separator"
                                role="separator"
                                [ngClass]="{
                                    'p-hidden': (item.isVisible | async) === false || (submenu.isVisible | async) === false, 
                                    'p-disabled': (item.isEnabled | async) === false || (submenu.isEnabled | async) === false
                                }">
                            </li>
                        } @else {
                            <li role="none"
                                class="p-menuitem"
                                [ntsMenuItemContent]="item"
                                [template]="itemTemplate"
                                [ngClass]="{
                                    'p-hidden': (item.isVisible | async) === false || (submenu.isVisible | async) === false,
                                    'p-disabled': (item.isEnabled | async) === false || (submenu.isEnabled | async) === false
                                }"
                                [ngStyle]="item.style"
                                [class]="item.styleClass"></li>
                        }
                    }
                }
            } @else {
                @for(item of model; track item) {
                    @if(item.separator) {
                        <li class="p-menu-separator"
                            role="separator"
                            [ngClass]="{
                                'p-hidden': (item.isVisible | async) === false,
                                'p-disabled': (item.isEnabled | async) === false
                            }"></li>
                    } @else {
                        <li class="p-menuitem"
                            role="none"
                            [ntsMenuItemContent]="item"
                            [template]="itemTemplate"
                            [ngClass]="{
                                'p-hidden': (item.isVisible | async) === false,
                                'p-disabled': (item.isEnabled | async) === false
                            }"
                            [ngStyle]="item.style"
                            [class]="item.styleClass"></li>
                    }
                }
            }
        </ul>
    </div>
}